import { Injectable } from '@angular/core';
import { CrossFrameBridgeOptions } from './cross-frame-bridge';
import { CrossFrameObservableBridge } from './cross-frame-observable-bridge';

@Injectable({
  providedIn: 'root'
})
export class CrossFrameBridgeFactory {
  constructor() {}

  create(options: CrossFrameBridgeOptions): CrossFrameObservableBridge {
    return new CrossFrameObservableBridge(options);
  }
}
